import { Section } from './section';
import React from 'react';
import { useSelector } from 'react-redux';
import contactImage from 'assets/img/polarpumpen/contact-image.png';
import { isMobile as isMobileSelector, isMobileLayout } from 'components/Shared/responsive';
import { CardLayout } from './layout';
import { CardProps } from './types';
import { CardInformation } from './information';
import { Button } from 'components/Button';
import styles from './styles.scss';
import { IconPhone } from 'components/Shared/Icon';

export const Card = ({ image, button, categoryUrl, appearance = 'card' }: CardProps) => {
  const isMobile = useSelector(isMobileSelector);
  const { title } = button;

  return (
    <CardLayout
      image={image}
      categoryUrl={categoryUrl}
      appearance={appearance}
      hasSpacing={!isMobile}
    >
      <Button title={title} size="small">
        <p>{title}</p>
      </Button>
    </CardLayout>
  );
};

export const CardMedium = ({ image, button, categoryUrl, appearance = 'card' }: CardProps) => {
  const isMobile = useSelector(isMobileSelector);
  const { title, text } = button;

  return (
    <CardLayout
      image={image}
      categoryUrl={categoryUrl}
      appearance={appearance}
      hasSpacing={!isMobile}
    >
      <Button title={title} className={styles.column} appearance="secondary" size="small">
        <p>{title}</p>
        <p className={styles.thin}>{text}</p>
      </Button>
    </CardLayout>
  );
};

export const CardLarge = ({
  button,
  information,
  appearance = 'card',
  categoryUrl = '',
  image
}: CardProps) => {
  return (
    <CardLayout image={image} categoryUrl={categoryUrl} appearance={appearance} hasSpacing>
      <CardInformation
        title={information?.title}
        text={information?.text}
        appearance={appearance}
      />
      <Button title={button?.title} size="small">
        <p>{button?.title}</p>
      </Button>
    </CardLayout>
  );
};

export const CardContact = ({ button, appearance = 'contact' }: CardProps) => {
  const isMobileAndTablet = useSelector(isMobileLayout);
  const isMobile = useSelector(isMobileSelector);
  const { title } = button;

  return (
    <CardLayout
      path={contactImage}
      appearance={appearance}
      section={<Section title={title} />}
      hasSpacing={!isMobile}
    >
      {isMobileAndTablet && (
        <Button title={title} size="small">
          <IconPhone fill className={styles.icon} />
          <p>{title}</p>
        </Button>
      )}
    </CardLayout>
  );
};
